/* This is the EMIS 2 shift staff school components */
<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table style="height: 72px" border="1px;" width="390" cellspacing="0px;">
        <tbody>
          <tr style="height: 25px">
            <td
              style="
                width: 140px;
                height: 50px;
                text-align: center;
                vertical-align: middle;
              "
              rowspan="2"
            >
              បរិយាយ
            </td>
            <td class="row-header" colspan="2">បុគ្គលិកបង្រៀន២វេន</td>
            <td class="row-header" colspan="2">បុគ្គលិកបង្រៀនថ្នាក់គួប</td>
          </tr>
          <tr style="height: 25px">
            <td
              style="
                width: 60px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              សរុប
            </td>
            <td class="row-data">ស្រី</td>
            <td class="row-data">សរុប</td>
            <td class="row-data">ស្រី</td>
          </tr>
          <tr style="height: 25px">
            <td
              style="
                width: 60px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              គ្រូក្របខ័ណ្ឌ
            </td>
            <td class="row-data">
              <numberinput v-model="data[0].dt[0]" class="number" />
            </td>
            <td class="row-data">
              <numberinput v-model="data[0].dt[1]" class="number" />
            </td>
            <td class="row-data">
              <numberinput v-model="data[0].dt[2]" class="number" />
            </td>
            <td class="row-data">
              <numberinput v-model="data[0].dt[3]" class="number" />
            </td>
          </tr>
          <tr style="height: 25px">
            <td
              style="
                width: 60px;
                height: 25px;
                text-align: right;
                vertical-align: middle;
              "
              colspan="3"
            >
              គ្រូក្របខ័ណ្ឌមកពីកន្លែងផ្សេងកំពុងជួយបង្រៀន
            </td>
            <td class="row-data">
              <numberinput v-model="data[1].dt[2]" class="number" />
            </td>
            <td class="row-data">
              <numberinput v-model="data[1].dt[3]" class="number" />
            </td>
          </tr>
          <tr style="height: 25px">
            <td
              style="
                width: 60px;
                height: 25px;
                text-align: right;
                vertical-align: middle;
              "
              colspan="3"
            >
              ចំនួនគ្រូជាប់កិច្ចសន្យាកំពុងជួយបង្រៀន
            </td>
            <td class="row-data">
              <numberinput v-model="data[2].dt[2]" class="number" />
            </td>
            <td class="row-data">
              <numberinput v-model="data[2].dt[3]" class="number" />
            </td>
          </tr>
          <tr style="height: 25px">
            <td
              style="
                width: 60px;
                height: 25px;
                text-align: right;
                vertical-align: middle;
              "
              colspan="3"
            >
              ចំនួនបុគ្គលិកពិការភាព
            </td>
            <td class="row-data">
              <numberinput v-model="data[3].dt[2]" class="number" />
            </td>
            <td class="row-data">
              <numberinput v-model="data[3].dt[3]" class="number" />
            </td>
          </tr>
          <!--  add 24-25 -->
          <tr style="height: 25px">
            <td
              style="
                width: 60px;
                height: 25px;
                text-align: right;
                vertical-align: middle;
              "
              colspan="3"
            >
              ចំនួនបុគ្គលិកបង្រៀនដែលខ្វះ
            </td>
            <td class="row-data">
              <numberinput v-model="data[4].dt[2]" class="number" />
            </td>
            <td class="row-data">
              <numberinput v-model="data[4].dt[3]" class="number" />
            </td>
          </tr>
          <tr style="height: 25px">
            <td
              style="
                width: 60px;
                height: 25px;
                text-align: right;
                vertical-align: middle;
              "
              colspan="3"
            >
              ចំនួនបុគ្គលិកបង្រៀនដែលលើស
            </td>
            <td class="row-data">
              <numberinput v-model="data[5].dt[2]" class="number" />
            </td>
            <td class="row-data">
              <numberinput v-model="data[5].dt[3]" class="number" />
            </td>
          </tr>
          <tr style="height: 25px">
            <td
              style="
                width: 60px;
                height: 25px;
                text-align: right;
                vertical-align: middle;
              "
              colspan="3"
            >
              បុគ្គលិកបង្រៀនទទួលការបណ្តុះបណ្តាលថ្នាក់បរិយាបន្ន
            </td>
            <td class="row-data">
              <numberinput v-model="data[6].dt[2]" class="number" />
            </td>
            <td class="row-data">
              <numberinput v-model="data[6].dt[3]" class="number" />
            </td>
          </tr>
          <tr style="height: 25px">
            <td
              style="
                width: 60px;
                height: 25px;
                text-align: right;
                vertical-align: middle;
              "
              colspan="3"
            >
              បុគ្គលិកបង្រៀនបានធ្វើបច្ចុប្បន្នកម្មកិច្ចតែងការ
            </td>
            <td class="row-data">
              <numberinput v-model="data[7].dt[2]" class="number" />
            </td>
            <td class="row-data">
              <numberinput v-model="data[7].dt[3]" class="number" />
            </td>
          </tr>
          <!-- add 25-26 -->
          <tr style="height: 25px">
            <td
              style="
                width: 60px;
                height: 25px;
                text-align: right;
                vertical-align: middle;
              "
              colspan="3"
            >
              សរុបចំនួបបុគ្គលិកបង្រៀននៅមត្តេយ្យសិក្សា
            </td>
            <td class="row-data">
              <numberinput v-model="data[8].dt[2]" class="number" />
            </td>
            <td class="row-data">
              <numberinput v-model="data[8].dt[3]" class="number" />
            </td>
          </tr>
          <tr style="height: 25px">
            <td
              style="
                width: 60px;
                height: 25px;
                text-align: right;
                vertical-align: middle;
              "
              colspan="3"
            >
              ចំនួនបុុគ្គលិកបង្រៀននៅមត្តេយ្យសិក្សាដែលបានឆ្លងកាត់ការបណ្តុះបណ្តាលពីសាលាគរុកោសល្យមត្តេយ្យមជ្ឍឺម
            </td>
            <td class="row-data">
              <numberinput v-model="data[9].dt[2]" class="number" />
            </td>
            <td class="row-data">
              <numberinput v-model="data[9].dt[3]" class="number" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {};
  },
};
</script>
<style scoped>
.number {
  width: 60px;
  text-align: center;
}
.row-data {
  width: 60px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-header {
  width: 120px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
</style>